<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="min(600px, calc(100vw - 32px))">
    <template slot="title">
      <span>{{ dialogTitle }}</span>
      <span v-if="showViewToolbar" class="title-actions">
        <el-button v-if="isAuth('base:workShop:update')" type="primary" size="small" @click="editFromView">修改</el-button>
        <el-button v-if="isAuth('base:workShop:delete')" type="primary" size="small" :disabled="actionLoading" @click="deleteFromView">删除</el-button>
      </span>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="90px" @keyup.enter.native="dialogReadonly ? undefined : dataFormSubmit()">
      <el-form-item label="车间编码" prop="workShopCode">
        <el-input v-model="dataForm.workShopCode" :disabled="dialogReadonly" placeholder="车间编码" />
      </el-form-item>
      <el-form-item label="车间名称" prop="workShopName">
        <el-input v-model="dataForm.workShopName" :disabled="dialogReadonly" placeholder="车间名称" />
      </el-form-item>
      <el-form-item label="负责人" prop="managerId">
        <el-select v-model="dataForm.managerId" :disabled="dialogReadonly" filterable clearable placeholder="请选择负责人" style="width:100%">
          <el-option v-for="item in managerList" :key="item.userId" :label="item.username" :value="item.userId" />
        </el-select>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="dataForm.address" :disabled="dialogReadonly" placeholder="地址" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="dataForm.remark" :disabled="dialogReadonly" type="textarea" :rows="3" placeholder="备注" />
      </el-form-item>
      <el-form-item label="启用状态" prop="isenabled">
        <el-radio-group v-model="dataForm.isenabled" :disabled="dialogReadonly">
          <el-radio label="0">启用</el-radio>
          <el-radio label="1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!dialogReadonly" type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import { checkAuth } from '../../utils/isAuth'

function blankForm() {
  return {
    workShopId: '',
    version: 0,
    workShopCode: '',
    workShopName: '',
    managerId: '',
    address: '',
    remark: '',
    isenabled: '0'
  }
}

export default {
  data() {
    const validateCode = (rule, value, callback) => {
      if (!/\S/.test(value || '')) callback(new Error('车间编码不能为空'))
      else callback()
    }
    const validateName = (rule, value, callback) => {
      if (!/\S/.test(value || '')) callback(new Error('车间名称不能为空'))
      else callback()
    }
    return {
      visible: false,
      dialogReadonly: false,
      actionLoading: false,
      managerList: [],
      permCodes: [],
      dataForm: blankForm(),
      dataRule: {
        workShopCode: [{ required: true, validator: validateCode, trigger: 'blur' }],
        workShopName: [{ required: true, validator: validateName, trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.dialogReadonly) return '查看车间'
      return this.dataForm.workShopId ? '修改车间' : '新增车间'
    },
    showViewToolbar() {
      return this.dialogReadonly && !!this.dataForm.workShopId
    }
  },
  created() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
  methods: {
    isAuth(perm) { return checkAuth(this.$store.state.user, this.permCodes, perm) },
    editFromView() { this.dialogReadonly = false },
    deleteFromView() {
      const id = this.dataForm.workShopId
      this.$confirm('确定删除该车间？', '提示', { type: 'warning' }).then(() => {
        this.actionLoading = true
        request.post('/base/workShop/delete', [id]).then(() => {
          this.actionLoading = false
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => { this.actionLoading = false })
      }).catch(() => {})
    },
    handleConcurrentConflict(msg) {
      const text = msg || '操作失败'
      if (text.indexOf('数据已被其他用户更新') === -1 || !this.dataForm.workShopId) return
      this.$confirm('当前数据已被其他用户更新，是否重新加载最新数据？', '提示', {
        confirmButtonText: '重新加载',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fetchDetail(this.dataForm.workShopId)
      }).catch(() => {})
    },
    init(id, readonly) {
      this.dialogReadonly = !!readonly
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm && this.$refs.dataForm.resetFields()
        this.dataForm = blankForm()
        this.dataForm.workShopId = id || ''
        this.loadManagerList()
        if (id) this.fetchDetail(id)
      })
    },
    loadManagerList() {
      request.get('/sys/users').then(res => {
        const list = res.data || []
        this.managerList = list.map(item => ({ userId: String(item.id), username: item.username }))
      }).catch(() => { this.managerList = [] })
    },
    fetchDetail(id) {
      request.get('/base/workShop/info/' + id).then(res => {
        const info = res.data || {}
        this.dataForm.workShopId = info.workShopId
        this.dataForm.version = info.version || 0
        this.dataForm.workShopCode = info.workShopCode
        this.dataForm.workShopName = info.workShopName
        this.dataForm.managerId = info.managerId == null ? '' : String(info.managerId)
        this.dataForm.address = info.address
        this.dataForm.remark = info.remark
        this.dataForm.isenabled = info.isenabled || '0'
      }).catch(() => {})
    },
    dataFormSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        const payload = {
          workShopId: this.dataForm.workShopId || undefined,
          version: this.dataForm.version,
          workShopCode: this.dataForm.workShopCode,
          workShopName: this.dataForm.workShopName,
          managerId: this.dataForm.managerId,
          address: this.dataForm.address,
          remark: this.dataForm.remark,
          isenabled: this.dataForm.isenabled
        }
        const path = this.dataForm.workShopId ? '/base/workShop/update' : '/base/workShop/save'
        request.post(path, payload).then(() => {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(err => {
          this.handleConcurrentConflict(err && err.message)
        })
      })
    }
  }
}
</script>

<style scoped>
.title-actions { float: right; margin-right: 28px; }
</style>
